import { DraftConfiguration } from '@/types';
import { getRotatedRect } from '@/utils/math/getRotatedRect';
import { getHasSoftBoundary } from '@/model/printArea/getHasSoftBoundary';
import { getCurrentSizeOfConfiguration } from './getCurrentSizeOfConfiguration';

// only works for rectangular soft boundaries, not cutouts (check in platform works the same)
export const getIsOutsideSoftBoundary = (configuration: DraftConfiguration) => {
  const boundary = configuration.printArea.boundary;
  if (getHasSoftBoundary(boundary)) {
    const size = getCurrentSizeOfConfiguration(configuration);
    const rect = getRotatedRect(configuration.rotation, {
      x: configuration.offset.x,
      y: configuration.offset.y,
      width: size.width,
      height: size.height,
    });

    return (
      rect.x > boundary.size.width ||
      rect.x + rect.width < 0 ||
      rect.y > boundary.size.height ||
      rect.y + rect.height < 0
    );
  }

  return false;
};
